module.exports = __webpack_public_path__ + "static/media/portal-sidebar-background-gradient.0f8d095d.png";